<template>
  <nav
    class="sidebar-nav"
    :class="{ sidebar_nav_close: isCollapse, sidebar_nav_open: !isCollapse }"
  >
    <div class="sideBar-left">
      <!-- logo -->
      <div class="sideBar-left-header">
        <div class="sideBar-left-header-logo" v-if="!isCollapse">
          <img src="../assets/images/v4_logo.png" alt="" />
          <!-- :class="{ 'logo-text-lan': lan === 'en_US' }" -->
          <div class="logo-text">
            <!-- 合约后台 -->
            {{ $t("lanV4.logoTxt2") }}
          </div>
        </div>
        <div
          class="sideBar-left-header-switch"
          :class="{ sideBar_switch_close: isCollapse }"
        >
          <div
            @mouseenter="menuHoverIndexOpen = 1"
            @mouseleave="menuHoverIndexOpen = 0"
            v-if="!isCollapse"
          >
            <!-- <svg
              class="icon icon-20"
              aria-hidden="true"
              v-if="!isCollapse && menuHoverIndexOpen === 0"
              @click="isCollapse = !isCollapse"
            >
              <use xlink:href="#icon-v4_openmenu"></use>
            </svg> -->
            <img
              v-if="!isCollapse && menuHoverIndexOpen === 0"
              @click="isCollapse = !isCollapse"
              src="../assets/images/agent_open.png"
              alt=""
            />
            <!-- <svg
              class="icon icon-20"
              aria-hidden="true"
              v-if="!isCollapse && menuHoverIndexOpen === 1"
              @click="isCollapse = !isCollapse"
            >
              <use xlink:href="#icon-v4_collapse_h"></use>
            </svg> -->
            <img
              v-if="!isCollapse && menuHoverIndexOpen === 1"
              @click="isCollapse = !isCollapse"
              src="../assets/images/agent_open.png"
              alt=""
            />
          </div>
          <div
            @mouseenter="menuHoverIndexClose = 1"
            @mouseleave="openMenuMouseLeave"
            v-if="isCollapse"
          >
            <!-- <svg
              class="icon icon-20"
              aria-hidden="true"
              v-if="isCollapse && menuHoverIndexClose === 0"
              @click="isCollapse = !isCollapse"
            >
              <use xlink:href="#icon-v4_collapse"></use>
            </svg> -->
            <img
              v-if="isCollapse && menuHoverIndexClose === 0"
              @click="isCollapse = !isCollapse"
              src="../assets/images/agent_open.png"
              alt=""
              style="transform: rotate(180deg);margin-left:-4px;"
            />
            <!-- <svg
              class="icon icon-20"
              aria-hidden="true"
              v-if="isCollapse && menuHoverIndexClose === 1"
              @click="isCollapse = !isCollapse"
            >
              <use xlink:href="#icon-v4_openmenu_h"></use>
            </svg> -->
            <img
              v-if="isCollapse && menuHoverIndexClose === 1"
              @click="isCollapse = !isCollapse"
              src="../assets/images/agent_open.png"
              alt=""
              style="transform: rotate(180deg);margin-left: -2px;;"
            />
            <!-- 收起 -->
          </div>
        </div>
      </div>
      <!-- 折叠菜单 -->
      <div class="sideBar-close-collapse" v-if="isCollapse">
        <el-menu
          :default-active="menuActiveRight"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          :unique-opened="unique"
        >
          <el-submenu
            :index="item.atName"
            v-for="item in menusInit"
            :key="item.id"
            :popper-class="menuActiveLeft === item.atName ? 'sidebar-empty-popper' : ''"
            :show-timeout="0"
            :hide-timeout="300"
          >
            <!-- 折叠一级菜单 -->
            <template slot="title">
              <div
                @mouseenter="menuHoverIndex = item.atName"
                @mouseleave="menuHoverIndex = null"
                @click="handleLeftMenuActive(item.atName)"
              >
                <div class="left-menu-icon" :class="{'left-menu-icon-active':menuHoverIndex === item.atName ||
                      menuActiveLeft === item.atName}">
                  <img
                    :class="getClass(item.atName)"
                    v-if="
                      menuHoverIndex === item.atName ||
                      menuActiveLeft === item.atName
                    "
                    style="width: 22px; height: 22px;margin-left:16px; object-fit: cover;position: relative;top:-3px;"
                    :src="require(`../assets/images/v4_${item.atName}_h.png`)"
                    alt=""
                  />
                  <img
                    :class="getClass(item.atName)"
                    style="width: 22px; height: 22px;margin-left:16px;object-fit: cover;position: relative;top:-3px;"
                    :src="require(`../assets/images/v4_${item.atName}.png`)"
                    v-else
                    alt=""
                  />
                </div>

                <span slot="title">{{ item.atDes }} </span>
              </div>
            </template>
            <template v-if="menuActiveLeft !== item.atName">
              <div
                class="sideBar-left-hover"
                v-for="(citem, index) in menus.menuList[item.atName]"
                :key="index"
              >
                <!--折叠二级菜单 -->
                <el-menu-item
                  :index="citem.atName"
                  @click="setActive(citem)"
                  v-if="
                    citem.child.length <= 0 &&
                    citem.atName !== 'SplitLine' &&
                    menuActiveLeft !== item.atName
                  "
                >
                  <div class="jt" v-if="index === 0"></div>
                  <div class="left-menu-text-hover">
                    {{ citem.atDes }}
                  </div>
                </el-menu-item>
              </div>
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <!-- 展开菜单 -->
      <div class="sideBar-open-collapse" v-if="!isCollapse">
        <el-menu
          :default-active="menuActiveLeft"
          @open="handleOpen"
          @close="handleClose"
          :collapse="true"
          :unique-opened="unique"
        >
          <el-submenu
            :index="item.atName"
            v-for="item in menusInit"
            :key="item.id"
            :class="{ 'is-active': menuActiveLeft === item.atName }"
            :popper-class="menuActiveLeft === item.atName ? 'sidebar-empty-popper' : ''"
            :show-timeout="0"
            :hide-timeout="300"
            @mouseenter.native="menuHoverIndex = item.atName"
            @mouseleave.native="menuHoverIndex = null"
            @click.native="handleLeftMenuActive(item.atName)"
          >
            <!--展开一级菜单 -->
            <template slot="title">
              <img
                class="left-menu-img"
                :class="getClass(item.atName)"
                v-if="
                  menuHoverIndex === item.atName ||
                  menuActiveLeft === item.atName
                "
                style="width: 22px; height: 22px; object-fit: cover"
                :src="require(`../assets/images/v4_${item.atName}_h.png`)"
                alt=""
              />
              <img
                class="left-menu-img"
                :class="getClass(item.atName)"
                v-else
                style="width: 22px; height: 22px; object-fit: cover"
                :src="require(`../assets/images/v4_${item.atName}.png`)"
                alt=""
              />
              <div class="left-menu-text">
                {{ item.atDes }}
              </div>
            </template>
            <template v-if="menuActiveLeft !== item.atName">
              <div
                class="sideBar-left-hover"
                v-for="(citem, index) in menus.menuList[item.atName]"
                :key="index"
              >
                <!-- 展开二级菜单 -->
                <el-menu-item
                  :index="citem.atName"
                  @click="setActive(citem)"
                  v-if="
                    citem.child.length <= 0 &&
                    citem.atName !== 'SplitLine' &&
                    menuActiveLeft !== item.atName
                  "
                >
                  <div class="jt" v-if="index === 0"></div>
                  <div class="left-menu-text-hover">
                    {{ citem.atDes }}
                  </div>
                </el-menu-item>
              </div>
            </template>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <!-- 右侧固定菜单 -->
    <div class="sideBar-right">
      <div class="sideBar-right-content">
        <el-menu
          :default-active="menuActiveRight"
          @open="handleOpen"
          @close="handleClose"
          :unique-opened="unique"
        >
          <!-- 显示模块名字 -->
          <div class="menuActiveLeftText" v-if="isCollapse">
            {{ menuActiveLeftText }}
          </div>
          <div
            v-for="(item, index) in navItems"
            :key="index"
            @mouseenter="menuHoverIndex = item.url"
            @mouseleave="menuHoverIndex = null"
          >
            <!-- 右侧固定二级导航 -->
            <el-menu-item
              :index="item.url"
              @click="setActive(item)"
              v-if="!item.children && item.url !== 'SplitLine'"
              :class="{ 'is-active': $route.meta.atName === item.url }"
            >
              <img
                class="right-menu-img"
                :class="getClass(item.url)"
                v-if="
                  item.icon &&
                  (menuHoverIndex === item.url || menuActiveRight === item.url)
                "
                :src="require(`../assets/images/v4_${item.url}_h.png`)"
                alt=""
              />
              <img
                class="right-menu-img"
                :class="getClass(item.url)"
                v-else-if="item.icon"
                :src="require(`../assets/images/v4_${item.url}.png`)"
                alt=""
              />
              <div class="right-menu-text">
                {{ item.name }}
              </div>
            </el-menu-item>
            <!-- 分隔线 -->
            <div class="sideBar-divider" v-if="item.url === 'SplitLine'"></div>
          </div>
        </el-menu>
      </div>
    </div>
  </nav>
</template>

<script>
import transition from "./transition";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import commonMixin from "@/mixin/common/commonMixin";
export default {
  mixins: [commonMixin],
  data() {
    return {
      isCollapse: false,
      headerActive: "",
      unique: true, // 菜单是否只保持一个子菜单的展开
      menuActiveLeft: "", //左边一级菜单选中路由
      menuActiveLeftText: "", //左边一级菜单选中路由文案
      menuActiveRight: "", //右边二级菜单选中路由
      menuHoverIndex: null,
      menuHoverIndexOpen: 0,
      menuHoverIndexClose: 0,
    };
  },
  components: {
    VuePerfectScrollbar,
    transition,
  },
  props: {
    open: {
      type: String,
      default: "",
    },
    active: {
      type: String,
      default: "",
    },
  },
  watch: {
    menus: {
      immediate: true,
      handler(v) {
        if (v) {
          // this.getActiveMenus();
        }
      },
    },
    $route: {
      immediate: true,
      handler(v) {
        if (v) {
          this.getActiveMenus();
        }
      },
    },
    isCollapse(val) {
      this.$emit("setCollapse", val);
    },
  },
  methods: {
    openMenuMouseLeave() {
      this.menuHoverIndexClose = 0;
      this.menuHoverIndexOpen = 0;
    },
    // *************
    // 菜单长度
    getMenuLength(val, atName) {
      if (
        atName === "liquidationPositionDetail" ||
        atName === "underlyingPriceManageList"
      ) {
        if (this.lan === "en_US") {
          return 10;
        } else {
          return val.length;
        }
      } else if (atName === "userFeeInfoList") {
        if (this.lan === "en_US") {
          return 10;
        } else {
          return val.length;
        }
      } else {
        return val.length;
      }
    },
    // 刷新获取一二级当前选中菜单
    getActiveMenus() {
      const { meta } = this.$route;
      for (let key in this.menus.menuList) {
        this.deepMatchMenuIndexByPath(this.menus.menuList[key], meta.atName);
      }
      // this.menuActiveRight = meta.atName;
    },
    // 点击左侧选中菜单
    handleLeftMenuActive(atName) {
      // 使用指南处理
      if (atName === "agentUseGuide") {
        if (this.roleType == 0 || this.roleType == 1) {
          // 平台商户管理员跳转
          if (this.lan === "zh_CN" || this.lan === "el_GR" || this.lan === "zh_TC") {
            window.open("https://help.chainupcloud.com/pages/viewpage.action?pageId=44236862", "_blank");
          } else {
            window.open("https://help.chainupcloud.com/pages/viewpage.action?pageId=44236906", "_blank");
          }
        } else if (this.roleType == 3 || this.roleType == 4) {
          // 经纪人跳转
          if (this.lan === "zh_CN" || this.lan === "el_GR") {
            window.open(
              "https://futuresdoc.gitbook.io/futuresbroker_cn",
              "_blank"
            );
          } else if (this.lan === "zh_TC"&&this.companyId==1835) {
            // 商户自己翻译特殊处理
            window.open(
              "https://star-vaults.gitbook.io/futures-broker",
              "_blank"
            );
          } else{
            window.open(
              "https://futuresdoc.gitbook.io/futuresbroker_en",
              "_blank"
            );
          }
        }
      } else {
        this.headerActive = atName;
        let twoMenuArr = this.menus.menuList[atName][0];
        if (twoMenuArr && twoMenuArr.child.length > 0) {
          this.menuActiveRight = twoMenuArr.child[0].atName;
          this.$router.push(twoMenuArr.child[0].atName);
        } else {
          this.menuActiveRight = twoMenuArr.atName;
          this.$router.push(twoMenuArr.atName);
        }
      }
    },
    // 计算一二级菜单当前选中的是什么
    deepMatchMenuIndexByPath(menuList, path, twoMenu) {
      return menuList.findIndex((menu) => {
        if (menu.atName == path) {
          this.menuActiveRight = menu.atName; //右边当前页面url选中的atName
          this.menus.navList.forEach((citem) => {
            if (twoMenu) {
              if (twoMenu.parentId == citem.id) {
                this.menuActiveLeft = citem.atName;
                this.menuActiveLeftText = citem.atDes;
                this.headerActive = this.menuActiveLeft;
              }
            } else {
              if (menu.parentId == citem.id) {
                this.menuActiveLeft = citem.atName;
                this.menuActiveLeftText = citem.atDes;
                this.headerActive = this.menuActiveLeft;
              }
            }
          });
        }
        if (menu.child) {
          return this.deepMatchMenuIndexByPath(menu.child, path, menu) !== -1;
        }
      });
    },
    // ***********
    setOpen(v) {
      if (v === this.open) {
        this.$emit("setOpen", "");
      } else {
        this.$emit("setOpen", v);
      }
    },
    setActive(item) {
      // this.$emit("setActive", v);
      this.$router.push(item.url);
      this.$router.push(item.atName);
      this.$emit("setActive", item);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    getClass(atName) {
      return atName;
    },
  },
  computed: {
    menus() {
      return this.$store.state.baseData.menus;
    },
    menusFilter() {
      return this.$store.state.baseData.menusFilter;
    },
    navItems() {
      let list = [];
      if (this.menus && this.menus.menuList[this.headerActive]) {
        this.menus.menuList[this.headerActive].forEach((item) => {
          const obj = {
            name: item.atDes,
            url: `${item.atName}`,
            icon: item.icon || "",
            id: item.id,
          };
          if (item.child.length) {
            let arr = [];
            item.child.forEach((citem) => {
              arr.push({
                name: citem.atDes,
                url: `${citem.atName}`,
                icon: citem.icon || "",
                id: item.id,
              });
            });
            obj.children = arr;
          }
          list.push(obj);
        });
      }
      return list;
    },
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: (styles) => ({ ...styles, height: 0 }),
      };
    },
    menusInit() {
      let list = [];
      if (this.menus) {
        list = this.menus.navList;
      }
      return list;
    },
    lan() {
      return this.$store.state.baseData.language;
    },
       // 登录的商户ID
    companyId() {
      if (this.$store.state.baseData.user) {
        return this.$store.state.baseData.user.companyId
      }
    },
  },
};
</script>
<style lang="scss">
:root {
  --sidebar-width: 350px;
  --sidebar-primary-width: 180px;
  --sidebar-primary-collapsed-width: 54px;
  --sidebar-secondary-width: 170px;
  --sidebar-secondary-content-width: 130px;
  --ui-color-primary: #3370FF;
  --ui-color-primary-hover: #EEF3FF;
  --ui-color-menu-text: #384A63;
  --ui-radius-button: 8px;
  --ui-primary-icon-filter: var(--theme-primary-icon-filter);
  --ui-menu-icon-filter: brightness(0) saturate(100%) invert(27%) sepia(22%) saturate(859%) hue-rotate(176deg) brightness(93%) contrast(89%);
  --ui-white-icon-filter: brightness(0) invert(1);
}

.sidebar {
  width: 0px !important;
}

.sidebar-nav {
  position: relative;
  width: var(--sidebar-width) !important;
  height: 100vh;

  .el-menu {
    border-right: 0;
  }

  .sideBar-left {
    width: var(--sidebar-primary-width);
    background: #F7F8F9;
    height: 100vh;
    position: relative;

    // 一级菜单class
    .sideBar-left-header {
      height: 60px;
      line-height: 60px;
      overflow: hidden;
      position: relative;

      .sideBar-left-header-logo {
        display: flex;
        margin-left: 16px;
        float: left;

        img {
          width: 32px;
          height: 20px;
          display: inline-block;
          margin-right: 6px;
          margin-top: 18px;
          display: none;
        }

        .logo-text {
          font-family: "HarmonyOS-Bold" !important;
          font-size: 16px;
          color: #1b1f26;
          width: 95px;
          word-break: break-all;
          word-wrap: break-word;
          // white-space: pre-wrap;
        }

        .logo-text-lan {
          line-height: 20px;
          margin-top: 9px;
        }
      }

      .sideBar-left-header-switch {
        float: right;
        margin-right: 14px;
        margin-top: 0px;
        cursor: pointer;
      }

      .sideBar_switch_close {
        position: absolute;
        left: 20px;
      }
    }

    .sideBar-open-collapse {
      .el-menu--collapse {
        width: var(--sidebar-primary-width);
        background: transparent;

        .el-submenu {
          width: var(--sidebar-primary-width);
          background: transparent;

          .el-submenu__title {
            width: var(--sidebar-primary-width);
            height: 40px !important;
            padding: 0 20px !important;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            white-space: normal;
            line-height: 40px !important;
            font-family: "HarmonyOS-Regular";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            overflow: hidden;
            color: var(--ui-color-menu-text);
            margin: 0 0 9px;
            background: transparent;
            border-radius: var(--ui-radius-button);

            .left-menu-img {
              flex: 0 0 18px;
              width: 18px !important;
              height: 18px !important;
              margin: 0 10px 0 0 !important;
              filter: var(--ui-menu-icon-filter);
            }

            .left-menu-text,
            .menu-jz-right,
            .noteBar {
              color: inherit;
            }

            .icon,
            i {
              color: inherit;
              fill: currentColor;
              stroke: currentColor;
            }
          }

          &.is-active > .el-submenu__title,
          > .el-submenu__title:hover,
          > .el-submenu__title:focus {
            color: var(--ui-color-primary) !important;
            background: var(--ui-color-primary-hover) !important;
            border-radius: var(--ui-radius-button) !important;
          }

          &.is-active > .el-submenu__title img,
          > .el-submenu__title:hover img,
          > .el-submenu__title:focus img {
            filter: var(--ui-primary-icon-filter);
          }
        }
      }

      .menu-jz {
        display: flex !important;
        align-items: center !important;
        height: 40px;

        .menu-jz-icon {
          line-height: 20px !important;
          width: 18px;
          height: 18px;
          margin: 0 10px 0 0;

          .img {
            display: inline-block;
          }
        }

        .menu-jz-right {
          width: auto !important;
          margin-left: 0 !important;
          font-family: "HarmonyOS-Regular" !important;
          font-style: normal !important;
          font-weight: 400 !important;
          font-size: 14px !important;
        }
      }
    }

    .sideBar-close-collapse {
      .el-menu {
        width: var(--sidebar-primary-collapsed-width) !important;
        background: transparent;
      }

      .el-submenu,
      .el-submenu__title,
      .el-submenu__title > div {
        width: var(--sidebar-primary-collapsed-width) !important;
        height: 40px !important;
        padding: 0 !important;
        margin: 0 0 9px !important;
        line-height: 40px !important;
        background: transparent;
        border-radius: var(--ui-radius-button);
        color: var(--ui-color-menu-text);
        font-family: "HarmonyOS-Regular";
        font-size: 14px;
        font-weight: 400;
      }

      .left-menu-icon {
        width: var(--sidebar-primary-collapsed-width);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        background: transparent;
        border-radius: var(--ui-radius-button);

        img {
          width: 18px !important;
          height: 18px !important;
          margin: 0 !important;
          top: 0 !important;
          filter: var(--ui-menu-icon-filter);
        }
      }

      .left-menu-icon-active,
      .el-submenu.is-active > .el-submenu__title,
      .el-submenu__title:hover,
      .el-submenu__title:focus {
        color: var(--ui-color-primary) !important;
        background: var(--ui-color-primary-hover) !important;
        border-radius: var(--ui-radius-button) !important;
      }

      .left-menu-icon-active img,
      .el-submenu.is-active > .el-submenu__title img,
      .el-submenu__title:hover img,
      .el-submenu__title:focus img {
        filter: var(--ui-primary-icon-filter);
      }

      .el-submenu__title .icon,
      .el-submenu__title i {
        color: inherit;
        fill: currentColor;
        stroke: currentColor;
      }
    }
  }

  // 右侧固定
  .sideBar-right {
    width: var(--sidebar-secondary-width);
    position: absolute;
    top: 0px;
    left: var(--sidebar-primary-width);
    background: #FFFFFF;
    height: 100vh;

    .sideBar-right-content {
      width: var(--sidebar-secondary-content-width);
      margin-left: 20px;
      margin-top: 76px;

      .el-menu,
      .el-menu > div {
        width: var(--sidebar-secondary-content-width);
        background: transparent;
      }

      .menuActiveLeftText {
        color: var(--ui-color-menu-text);
        font-family: "HarmonyOS-Regular";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        position: relative;
        top: -6px;
      }

      .el-menu-item {
        position: relative;
        width: var(--sidebar-secondary-content-width);
        height: 32px !important;
        padding: 0 10px !important;
        box-sizing: border-box;
        margin-top: 10px;
        display: flex;
        align-items: center;
        overflow: hidden;
        font-size: 12px;
        font-family: "HarmonyOS-Regular";
        font-weight: 400;
        white-space: normal;
        line-height: 32px !important;
        color: var(--ui-color-menu-text);
        background: transparent;
        border-radius: var(--ui-radius-button);

        .right-menu-img {
          flex: 0 0 18px;
          width: 18px !important;
          height: 18px !important;
          margin: 0 10px 0 0;
          display: block;
          filter: var(--ui-menu-icon-filter);
        }

        .right-menu-text,
        .noteBar,
        .badge {
          color: inherit;
        }

        .noteBar {
          margin-top: -4px;
        }
      }

      .el-submenu__title {
        .icon {
          margin-right: 10px;
          margin-left: -10px;
        }
      }

      .el-menu-item .icon,
      .el-menu-item i {
        color: inherit;
        fill: currentColor;
        stroke: currentColor;
      }
    }

    .el-menu-item:hover,
    .el-menu-item:focus {
      width: var(--sidebar-secondary-content-width);
      color: var(--ui-color-primary) !important;
      background: var(--ui-color-primary-hover) !important;
      border-radius: var(--ui-radius-button) !important;
      font-family: "HarmonyOS-Regular";
      font-size: 12px;
    }

    .el-menu-item:hover img,
    .el-menu-item:focus img {
      filter: var(--ui-primary-icon-filter);
    }

    .el-menu-item:hover .icon,
    .el-menu-item:focus .icon {
      color: var(--ui-color-primary);
      fill: currentColor;
      stroke: currentColor;
    }

    .el-menu-item.is-active,
    .el-menu-item.is-active:hover,
    .el-menu-item.is-active:focus {
      width: var(--sidebar-secondary-content-width);
      color: #FFFFFF !important;
      background: var(--ui-color-primary) !important;
      border-radius: var(--ui-radius-button) !important;
    }

    .el-menu-item.is-active img,
    .el-menu-item.is-active:hover img,
    .el-menu-item.is-active:focus img {
      filter: var(--ui-white-icon-filter);
    }

    .el-menu-item.is-active .icon,
    .el-menu-item.is-active:hover .icon,
    .el-menu-item.is-active:focus .icon {
      color: #FFFFFF;
      fill: currentColor;
      stroke: currentColor;
    }
  }
}

.sidebar_nav_close {
  width: calc(var(--sidebar-primary-collapsed-width) + var(--sidebar-secondary-width)) !important;

  .sideBar-left {
    width: var(--sidebar-primary-collapsed-width);
  }

  .sideBar-right {
    left: var(--sidebar-primary-collapsed-width);
  }
}

.sidebar_nav_open {
  width: var(--sidebar-width) !important;
}

// 折叠hover菜单样式
.el-menu--vertical {
  width: 150px;
  overflow: visible !important;
  z-index: 3000 !important;

  .el-menu--popup {
    width: 140px !important;
    min-width: 140px !important;
    box-sizing: border-box;
    overflow: visible !important;
    background: #FFFFFF !important;
    border: 0 !important;
    border-radius: var(--ui-radius-button) !important;
    margin-left: 10px;
    padding: 0 !important;
    box-shadow: 0 3px 8px rgba(14, 24, 44, 0.303404) !important;

    .sideBar-left-hover {
      width: 140px;
      position: relative;

      &:first-child {
        margin-top: 10px;
      }

      .jt {
        width: 0;
        height: 0;
        border-width: 8px;
        border-style: solid;
        border-color: transparent #FFFFFF transparent transparent;
        position: absolute;
        top: 8px;
        left: -16px;
        z-index: 1;
        pointer-events: none;
      }

      .el-menu-item {
        width: 140px;
        height: 32px !important;
        padding: 0 10px !important;
        box-sizing: border-box;
        display: flex !important;
        align-items: center !important;
        white-space: normal;
        line-height: 32px !important;
        font-family: "HarmonyOS-Regular";
        font-weight: 400;
        overflow: hidden;
        font-size: 12px;
        color: var(--ui-color-menu-text) !important;
        background: transparent !important;
        border-radius: var(--ui-radius-button);
        margin: 0 0 10px;
        position: relative;

        .left-menu-text-hover,
        .noteBar,
        .badge {
          color: inherit;
        }

        .left-menu-text-hover {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .icon {
          width: 18px;
          height: 18px;
          margin: 0 10px 0 0;
          color: inherit;
          fill: currentColor;
          stroke: currentColor;
        }

        i {
          color: inherit;
        }

        img {
          width: 18px;
          height: 18px;
          margin: 0 10px 0 0;
          filter: var(--ui-menu-icon-filter);
        }
      }

      .el-menu-item:hover,
      .el-menu-item:focus {
        color: var(--ui-color-primary) !important;
        background: var(--ui-color-primary-hover) !important;
        border-radius: var(--ui-radius-button) !important;
      }

      .el-menu-item:hover .icon,
      .el-menu-item:focus .icon {
        color: var(--ui-color-primary);
        fill: currentColor;
        stroke: currentColor;
      }

      .el-menu-item:hover img,
      .el-menu-item:focus img {
        filter: var(--ui-primary-icon-filter);
      }

      .el-menu-item.is-active,
      .el-menu-item.is-active:hover,
      .el-menu-item.is-active:focus {
        color: #FFFFFF !important;
        background: var(--ui-color-primary) !important;
        border-radius: var(--ui-radius-button) !important;
      }

      .el-menu-item.is-active .icon,
      .el-menu-item.is-active:hover .icon,
      .el-menu-item.is-active:focus .icon {
        color: #FFFFFF;
        fill: currentColor;
        stroke: currentColor;
      }

      .el-menu-item.is-active img,
      .el-menu-item.is-active:hover img,
      .el-menu-item.is-active:focus img {
        filter: var(--ui-white-icon-filter);
      }
    }
  }

  .el-menu--popup:empty {
    display: none !important;
    min-width: 0 !important;
    width: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}

.sidebar-empty-popper {
  display: none !important;
}

@media screen and (max-width: 992px) {
  .sideBar-right {
    display: block;
  }
}

.sideBar-divider {
  margin-top: 5px;
  border-bottom: 1px solid #ebebeb;
}
</style>
